/**
 * cart-actions.js
 * Remove and quantity handling for the cart page and the cart drawer.
 *
 * Markup contract (see sections/main-cart.liquid and sections/cart-drawer.liquid):
 *   [data-section-id="..."]        wrapper re-rendered via the Section Rendering API
 *   [data-cart-line]               one per line item
 *   [data-cart-remove="{key}"]     remove button
 *   [data-cart-quantity="{key}"]   number input
 *
 * v2: the live version shipped with this contract documented but no markup
 * anywhere in the theme implementing it. The markup now exists.
 */
(function () {
  function getSectionIds() {
    return Array.from(document.querySelectorAll('[data-section-id]')).map(function (el) {
      return el.getAttribute('data-section-id');
    });
  }

  function replaceSections(sections) {
    var replacedAny = false;
    Object.keys(sections || {}).forEach(function (id) {
      var target = document.querySelector('[data-section-id="' + id + '"]');
      if (!target) return;
      var temp = document.createElement('div');
      temp.innerHTML = sections[id];
      var fresh = temp.querySelector('[data-section-id="' + id + '"]') || temp.firstElementChild;
      if (fresh) { target.replaceWith(fresh); replacedAny = true; }
    });
    return replacedAny;
  }

  function removeLineFallback(key) {
    document.querySelectorAll('[data-cart-remove="' + key + '"]').forEach(function (btn) {
      var row = btn.closest('[data-cart-line]') || btn.closest('tr') || btn.closest('li');
      if (row) row.remove();
    });
  }

  function changeLine(key, quantity) {
    var sectionIds = getSectionIds();

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var replaced = sectionIds.length ? replaceSections(cart.sections) : false;

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

        if (!replaced) {
          if (quantity === 0) removeLineFallback(key);
          if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
        }
        return cart;
      })
      .catch(function (err) {
        console.error('[cart-actions] failed to update cart', err);
      });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.getAttribute('data-cart-remove');
    removeBtn.setAttribute('disabled', 'disabled');
    changeLine(key, 0);
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-quantity]');
    if (!qtyInput) return;
    var key = qtyInput.getAttribute('data-cart-quantity');
    var quantity = parseInt(qtyInput.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    changeLine(key, quantity);
  });
})();
